export default __webpack_public_path__ + "static/media/dashboardExpense.57c36f7e.svg";